import { z } from "zod";

const AllowedTypes = z.enum([
    "closed_to_arrival",
    "closed_to_departure",
    "max_stay",
    "min_stay_arrival",
    "min_stay_through",
    "stop_sell",
]);

const UpdateRestrictionResponse = z.object({
    data: z.object({
        type: AllowedTypes,
        value: z.string().min(1),
        rate_plan_id: z.string(), // Tidak selalu harus UUID
        date_ranges: z.array(z.object({
            date_from: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, "Invalid date format (YYYY-MM-DD)"),
            date_to: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, "Invalid date format (YYYY-MM-DD)")
        }))
    }).strict(), // Mencegah field tambahan

    success: z.coerce.boolean(), // Mengubah dari "true" (string) menjadi boolean
    message: z.string(),
    code: z.number().int().positive(), // Bisa untuk kode selain 200
}).strict(); // Mencegah field tambahan di root object

export type UpdateRestrictionResponseType = z.infer<typeof UpdateRestrictionResponse>;

export default UpdateRestrictionResponse;